const COMMON_ALPHA_SORT_ORDER = {
  AZ: 'az',
  ZA: 'za'
}

const COMMON_DATE_SORT_ORDER = {
  DESC: 'desc',
  ASC: 'asc'
}

const sortDataByDate = (data, order = COMMON_DATE_SORT_ORDER.DESC) => {
  if (data && data.length) {
    return data.sort((a, b) => {
      const dateA = new Date(a.insertedAt)
      const dateB = new Date(b.insertedAt)
      if (order === COMMON_DATE_SORT_ORDER.ASC) {
        return dateA - dateB
      } else if (order === COMMON_DATE_SORT_ORDER.DESC) {
        return dateB - dateA
      }
    })
  }
  return []
}

const sortRecordsByTitle = (records, order = COMMON_ALPHA_SORT_ORDER.AZ) => {
  if (records && records.length > 0) {
    return records.sort((a, b) => {
      if (order === COMMON_ALPHA_SORT_ORDER.AZ) {
        return a.title.localeCompare(b.title)
      } else if (order === COMMON_ALPHA_SORT_ORDER.ZA) {
        return b.title.localeCompare(a.title)
      }
    })
  }
  return []
}

export {
  COMMON_ALPHA_SORT_ORDER,
  COMMON_DATE_SORT_ORDER,
  sortDataByDate,
  sortRecordsByTitle
}
